import page from 'page'
import React from 'react'
import { isEmpty } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'

import { getFullInfo, getSimilar, subscribe } from '../store/reducers/lots/single.js'
import { getLoggedUser } from '../selectors/user.js'
import { getLotName, getSimilarLots, getLotInfo, getLastBidValue } from '../selectors/lots.js'

import moment from 'moment'

const lastBidHeader = value => <span><FormattedMessage id='lot.last_bid' /><br /><nobr>{value}</nobr></span>

const LotPage = ({ data = {}, name, closeBidOverlay, bidId, id, bidOverlay, onBidAdd}) => {
  if (!data || isEmpty(data)) return null
  data.title = name
  console.log(data)
  if (data.bidsStats){
    data.sum = data.bidsStats.maxBid + " " + data.currency.symbol
  }
  data.statsDifference = null
  
  function frameHeight(id){
    if(id.contentDocument) {
      id.height = id.contentDocument.documentElement.scrollHeight;
    } else {
      if(id.contentWindow) {
        id.height = id.contentWindow.document.body.scrollHeight;
      }
    }
  }

  return (
    <div className={"PreviewLots"}> 

      <div className={"Container"}> 
        <h1>Десктопная версия</h1>
        <iframe onload={frameHeight(this)} frameborder="0" id="iframe1" width="100%" height="800" src={"/previewlot/" + data._id}></iframe>
      </div>
      <div className={"Container"}> 
        <h1>Мобильная версия</h1>
        <iframe onload={frameHeight(this)} frameborder="0" id="iframe2" width="375" height="667" src={"/previewlot/" + data._id}></iframe>
      </div>

      <div className={"Container"}> 
        <h1>Автопостинг  в телеграме</h1>
        <div>
          <section className={"Persons__list"}>
            <div className={"Lot previewlots_tg_lot"}>
              <div className={"Lot__inner"}>
                <img className={"Lot__img"} src={data.socialImage}/>
              </div>
              <p className={"previewlots_tg_text"}>{data.title}</p>
              <p className={"previewlots_tg_text"}>{data.descriptions[0].minitext}</p>
              <p className={"previewlots_tg_text"}>{data.notifyText}</p>
            </div>
          </section>
        </div>
      </div>

      <div className={"Container"}> 
        <h1>Лот в боте</h1>
        <div>
          <section className={"Persons__list"}>
            <div className={"Lot previewlots_tg_lot"}>
              <div className={"Lot__inner"}>
                <img className={"Lot__img"} src={data.image}/>
              </div>
              <p className={"previewlots_tg_text"}>
                <h>{data.meta.persons}</h>
                <br></br>
                <h>{data.persons[0].job}</h>
              </p>
              <p className={"previewlots_tg_text"}>
                <h>Начальная ставка: {data.startBid} {data.currency.symbol}</h>
                <br></br>
                <h>Минимальный шаг: {data.bidStep} {data.currency.symbol}</h>
                <br></br>
                <h>Дата завершения аукциона: {moment(data.closeDate).format('DD.MM.YYYY')}</h>
                <br></br>
                <h>Фонд: {data.fund.name}</h>
              </p>
              <p className={"previewlots_tg_text"}>
                <h>{data.descriptions[0].smalltext.replace(/(<([^>]+)>)/ig, '')}</h>
              </p>
            </div>
          </section>
        </div>
      </div>

    </div>
  )}

const mapStateToProps = state => ({
  data: getLotInfo(state),
  similar: getSimilarLots(state),
  bids: state.lots.single.bids,
  bidMessage: state.lots.single.bidMessage,
  name: getLotName(state),
  lastBid: getLastBidValue(state),
  user: getLoggedUser(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({ getFullInfo, getSimilar, subscribe }, dispatch)

const mergeProps = (state, dispatch, props) => ({
  ...props,
  ...state,
  getFullInfo: async (id) => {
    id = id || props.id
    if (!id) return
    let result = await dispatch.getFullInfo(id, {typelot:'lot'})
    if (result === 200) await dispatch.getSimilar(id)
    else props.on404()
  },
  onBidAdd: async (id) => {
    id = id || props.id
    if (!id) return
    let result = await dispatch.getFullInfo(id, { noRewrite: true })
    if (result === 200) {
      props.setBidOverlay(false)
      page(`/lots/${id}`)
    }
  },
  subscribe: async flag => {
    if (!props.id || !state.data) return
    await dispatch.subscribe(props.id, !state.data.isSubscribed)
  }
})

export default injectIntl(compose(
  withState('bidLength', 'setBidLength', 5),
  withState('bidOverlay', 'setBidOverlay', null),
  withState('bidClosed', 'setBidClosed', false),
  withHandlers({
    lotClosed: (data) => (e) => {
      //скрываем кнопку Сделать ставку
      data.setBidClosed(true)
    },
    setBidOverlay: ({ setBidOverlay }) => (flag, e) => {
      e && e.preventDefault()
      setBidOverlay(flag)
    },
    setBidLength: ({ setBidLength }) => (num, e) => {
      e && e.preventDefault()
      setBidLength(num)
	  	  console.log('--------------num',num)
    },
    closeBidOverlay: ({ id, bidId, setBidOverlay }) => e => {
      e && e.preventDefault()
      setBidOverlay(false)
      if (bidId) page(`/lots/${id}`)
    }
  }),
  connect(mapStateToProps, mapDispatchToProps, mergeProps, state => ({currentLocale: state.intl.locale})),
  lifecycle({
    componentWillMount () {
      this.props.getFullInfo()
    },
    componentDidMount () {
      this.props.bidId && this.props.setBidOverlay(true)
    },
    componentWillReceiveProps (np) {
      if (np.bidId && (np.bidId !== this.props.bidId)) this.props.setBidOverlay(true)
      if (np.id && (np.id !== this.props.id)) this.props.getFullInfo(np.id)
    }
  })
)(LotPage))



// WEBPACK FOOTER //
// ./src/containers/PreviewLots.jsx